<template>
  <custom-link v-if="link" v-bind="link">
    <template #content>
      <slot></slot>
    </template>
  </custom-link>
  <div v-else class="custom-link">
    <div :class="css_class">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pad-link',

  props: {
    link: {
      type: Object,
      default: null,
    },
    css_class: {
      type: String,
      default: '',
    },
  },
}
</script>
